import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import { Table, Button, Icon, Tooltip } from 'antd';
import { baseUrl } from 'config/env.config';
import { toTimezone } from 'utils/dateTimeUtils';
import { getThemeByType } from 'utils/common';
import { Panel } from 'components/ui/index';
import { fetchExportHistory, handleCopyExportHistory, handlePinExportHistory } from '../flow/actions';
import styles from '../index.less';
import { getAuthorization } from 'utils/common';
import fetch from 'isomorphic-fetch';

const cx = classNames.bind(styles);

class ExportHistory extends React.Component {
  componentDidMount() {
    const { fetchExportHistory, exportHistory } = this.props;
    const { per_page, current_page } = exportHistory.pagination;
    fetchExportHistory(per_page, current_page);
  }

  handlePageChange = (page, pageSize) => {
    const { fetchExportHistory } = this.props;
    fetchExportHistory(pageSize, page);
  }

  handleDownload = (fileUrl, downloadUrl) => {
      const access_token = getAuthorization()
      fetch(`${fileUrl}`, {
        method: 'GET',
        headers: {
          Authorization: access_token
        }
      }).then(fileData => {
        return fileData.json()
      }).then(jsonFileData => {
        fetch(`${downloadUrl}`, {
          method: 'GET',
          headers: {
            Authorization: access_token,
          }
        }).then(res => {
          return res.blob()
        }).then(blob => {
          const a = document.createElement("a");
          const url = window.URL.createObjectURL(blob);
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = jsonFileData.data.name;
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        })
      })



     
  }

  renderColumns = () => {
    const { handleCopyExportHistory, handlePinExportHistory } = this.props;
    return (
      [
        {
          title: <FormattedMessage id="global.ui.table.action" />,
          key: 'id',
          render: record => {
            const theme = getThemeByType(record.object_type);
            return (
              <Fragment>
                <Tooltip
                  title={<FormattedMessage id="page.ObjectExport.clone" />}
                  placement="leftTop"
                >
                  <Icon
                    size="small"
                    type="block"
                    className={cx('icon-export')}
                    onClick={() => handleCopyExportHistory(record)}
                  />
                </Tooltip>
                <Tooltip
                  title={record.is_pin ? <FormattedMessage id="page.ObjectExport.unpin" /> : <FormattedMessage id="page.ObjectExport.pin" />}
                  placement="rightTop"
                >
                  <Icon
                    type="pushpin"
                    theme={record.is_pin ? 'filled' : 'outlined'}
                    className={classNames(cx('icon-export'), 'ml-md', record.is_pin ? `${theme}-theme-icon` : '')}
                    onClick={() => handlePinExportHistory(record.id, record.is_pin)}
                  />
                </Tooltip>
              </Fragment>
            );
          }
        },
        {
          title: <FormattedMessage id="page.ObjectExport.exportRequestId" />,
          dataIndex: 'receipt_no',
          key: 'receipt_no',
        },
        {
          title: <FormattedMessage id="page.ObjectExport.objectType" />,
          dataIndex: 'object_type',
          key: 'object_type',
        },
        {
          title: <FormattedMessage id="page.ObjectExport.exportDate" />,
          dataIndex: 'created_at',
          key: 'created_at',
          render: text => toTimezone(text, true),
        },
        {
          title: <FormattedMessage id="page.ObjectExport.info" />,
          dataIndex: 'error',
          key: 'error',
        },
        {
          title: <FormattedMessage id="page.ObjectExport.exportedBy" />,
          dataIndex: 'user_name',
          key: 'user_name'
        },
        {
          title: <FormattedMessage id="page.ObjectExport.status" />,
          key: 'status',
          render: (text, record) => {
            switch (record.status) {
              case 'succeeded':
                const theme = getThemeByType(record.object_type);
                const url = `${baseUrl}/admin/files/${record.export_file.id}/download`
                const file = `${baseUrl}/admin/files/${record.export_file.id}`
                return (
                  <div onClick = {() => this.handleDownload(file, url)} >
                    <Button className={`${theme}-theme-btn`}>
                      Download
                    </Button>
                  </div>
                );

              case 'failed':
                return (<span className={cx('history-status', 'status-failed')}>{record.status}</span>);

              case 'queueing':
              case 'processing':
                return (<span className={cx('history-status', 'status-processing')}>{record.status}</span>);

              default:
                return null;
            }
          }
        },
      ]
    );
  }

  render() {
    const { exportHistory } = this.props;
    const { historyData, pagination } = exportHistory;
    const { current_page, per_page, total } = pagination;

    const tablePagination = {
      current: current_page,
      pageSize: per_page,
      total,
      onChange: this.handlePageChange
    };

    return (
      <Panel
        panelTitle={<FormattedMessage id="page.ObjectExport.exportHistory" />}
      >
        <Table
          className="pl-lg pr-lg none-border-table"
          size="small"
          dataSource={historyData}
          columns={this.renderColumns()}
          rowKey={record => record.id}
          pagination={tablePagination}
        />
      </Panel>
    );
  }
}

const mapStateToProps = ({ setup, global }) => ({
  lang: global.language,
  exportHistory: setup.fileExport.exportHistory,
  objectType: setup.fileExport.objectType
});

const mapDispatchToProps = {
  fetchExportHistory,
  handleCopyExportHistory,
  handlePinExportHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportHistory);



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectExport/component/ExportHistory.jsx